import { render, staticRenderFns } from "./AllCorrect.vue?vue&type=template&id=b2024ed4&"
import script from "./AllCorrect.vue?vue&type=script&lang=js&"
export * from "./AllCorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports